import React from "react";

const CaseStudyBasicCard = ({
  title,
  description,
  subDescription,
  titleWidth,
  boxClassName = "",
}) => {
  return (
    <section className="flex flex-col px-4 md:px-32 py-40">
      <div
        className={`flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-5 ${boxClassName}`}
      >
        <h1
          className={`w-[70%] md:w-1/2 ${titleWidth} font-medium text-[32px] md:text-[48px] leading-[140%] tracking-[0%] text-[#AFAFAF]`}
        >
          {title}
        </h1>
        <div className="w-full text-start font-normal text-sm md:text-[20px] leading-[145%] tracking-[0%] pr-[8%]">
          <p>{description}</p>
        </div>
      </div>
      {subDescription && (
        <p className="text-[14px] md:text-[20px] pt-6">{subDescription}</p>
      )}
    </section>
  );
};

export default CaseStudyBasicCard;
